var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg50N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_648)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12.2647,
    width: 1.76471,
    height: 16,
    rx: 0.882353,
    transform: "rotate(-90 8 12.2647)",
    fill: "url(#paint0_linear_10214_648)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_10214_648)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18.2647,
    width: 1.76471,
    height: 6.58681,
    rx: 0.882353,
    transform: "rotate(-90 8 18.2647)",
    fill: "url(#paint1_linear_10214_648)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_10214_648)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15.5,
    width: 2,
    height: 9,
    rx: 1,
    transform: "rotate(-90 10 15.5)",
    fill: "url(#paint2_linear_10214_648)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_10214_648)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21.5,
    width: 2,
    height: 9,
    rx: 1,
    transform: "rotate(-90 11 21.5)",
    fill: "url(#paint3_linear_10214_648)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_648",
    x: -5.30527,
    y: -2.80527,
    width: 42.6105,
    height: 28.3752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_10214_648",
    x: -5.30527,
    y: 3.19473,
    width: 33.1974,
    height: 28.3752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_10214_648",
    x: -3.30527,
    y: 0.194735,
    width: 35.6105,
    height: 28.6105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_10214_648",
    x: -2.30527,
    y: 6.19473,
    width: 35.6105,
    height: 28.6105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_648",
    x1: 8.50905,
    y1: 15.7647,
    x2: 10.021,
    y2: 15.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_648",
    x1: 8.50905,
    y1: 19.7056,
    x2: 10.0105,
    y2: 19.8439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10214_648",
    x1: 10.75,
    y1: 25.75,
    x2: 5.03556,
    y2: 23.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519924,
    stopColor: "#ACACAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10214_648",
    x1: 12.6034,
    y1: 22.3582,
    x2: 10.1634,
    y2: 22.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50N);
export default __webpack_public_path__ + "static/media/50n.365281519f04a0574454ec0dfa7d070e.svg";
export { ForwardRef as ReactComponent };